/** "Hikvision" CCTV camera available directions */
export enum HikvisionCameraDirectionEnum {
  /** Entry direction: car number recognition events will transfer transit tasks to the "in process" status */
  ENTRY = 'ENTRY',
  /** Entry direction: car number recognition events will transfer transit tasks to the "completed" status */
  EXIT = 'EXIT',
}
